"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resyncFolders = void 0;
const redux_observable_1 = require("redux-observable");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const ResyncFoldersActions = require("../../../actions/vektorio/resyncFolders");
const ResyncFoldersActionTypes = require("../../../actionTypes/vektorio/resyncFolders");
const ajax_1 = require("../../../utils/ajax");
const errorHandling_1 = require("../../../utils/errorHandling");
function resyncFolders(action$, _store, { ajax, getToken, baseUrl }) {
    const getUrl = ({ projects }) => {
        const { sokopro, vektorio } = projects;
        return `${baseUrl}api/bim/projects/${sokopro}/vektorio/${vektorio}/folders/resync`;
    };
    const ajaxOptions = (payload) => {
        const { folderUuid } = payload;
        return {
            method: 'POST',
            headers: (0, ajax_1.getHeaders)(getToken),
            url: getUrl(payload),
            body: { folderUuids: [folderUuid] }
        };
    };
    const ajaxCall = ({ payload }) => {
        const onSuccess = () => (0, rxjs_1.of)(ResyncFoldersActions.success());
        const onFailure = (error) => (0, rxjs_1.of)(ResyncFoldersActions.failure((0, errorHandling_1.parseAjaxErrorResponse)(error)));
        return ajax(ajaxOptions(payload)).pipe((0, operators_1.mergeMap)(onSuccess), (0, operators_1.catchError)(onFailure));
    };
    return action$.pipe((0, redux_observable_1.ofType)(ResyncFoldersActionTypes.REQUEST), (0, operators_1.mergeMap)(ajaxCall));
}
exports.resyncFolders = resyncFolders;
//# sourceMappingURL=index.js.map